if (!customElements.get("pack-builder")) {
  customElements.define(
    "pack-builder",
    class PackBuilder extends HTMLElement {
      constructor() {
        super();
        this.products = [];
        this.variants = [];
        this.productsSelected = [];
        this.oldProductsSelected = [];
        this.size = 0;
        this.parent = this.closest(".product-info");
        this.deployerSuperiorOffer = this.closest("deployer-superior-offer");
        this.previousProperties = {};
        if (this.deployerSuperiorOffer) {
          this.previousProperties = JSON.parse(this.deployerSuperiorOffer.querySelector(".previous-properties").textContent);
        }
        this.infoContainer = this.parent.querySelector('.product-info__block-item[data-block-type="buy-buttons"] .product-info__pack-container');
        if (this.infoContainer != null) {
          let textElement = this.infoContainer.querySelector(".product-info__pack-text");
        }
      }

      connectedCallback() {
        this.initialize();
        this.addEventListeners();

        // Appliquer les classes pour les variantes populaires après l'initialisation
        this.stylizeVariantOptions();
      }

      initialize() {
        this.id = "pack-builder"; // Assure que l'ID est "pack-builder"

        // Récupération des données des produits depuis le script JSON
        const productsData = this.querySelector("#product-data");
        if (productsData) {
          this.products = JSON.parse(productsData.textContent);
        }

        // Récupération des données des variantes
        const variantsData = this.querySelector("#variants-data");
        if (variantsData) {
          this.variants = JSON.parse(variantsData.textContent);
          // Log de débogage pour vérifier les données des variantes
          console.log("Variantes chargées:", this.variants);
        }

        // Définir la taille limite des produits sélectionnables
        this.size = parseInt(this.getAttribute("data-limit"));

        // Stocker la limite maximale actuelle
        this.maxLimit = this.size;

        // Sélection des éléments nécessaires
        this.gridContainer = this.querySelector(".product_grid");
        this.packBuilderTitle = this.querySelector("h4");
        this.btnAddToCart = this.parent.querySelector(this.getAttribute("data-button-selector"));
        this.btnAddToCart.disabled = true;
        this.infoContainer = this.parent.querySelector('.product-info__block-item[data-block-type="buy-buttons"] .product-info__pack-container');
        this.textElement = this.infoContainer?.querySelector(".product-info__pack-text");
        this.popup = this.parent.querySelector("#product-info-popup_pack");
        this.popupContent = this.popup?.querySelector(".popup-description_pack");
        this.closePopup = this.popup?.querySelector(".close-popup_pack");

        this.updateTitle();
        this.renderProducts();

        // Attendre que le DOM soit prêt avant de sélectionner la variante populaire
        setTimeout(() => {
          this.selectPopularVariant();
        }, 500);

        this.initVariantChangeListener();
        this.applyPreviousProperties();
        this.handleInfoContainer(this.productsSelected.length);
        this.handleGridState(this.productsSelected.length);
      }

      updateTitle() {
        if (this.packBuilderTitle && this.packBuilderTitle.querySelector("span.size") == null) {
          this.packBuilderTitle.innerHTML = this.packBuilderTitle.innerHTML.replace("#", `<span class="size">${this.size}</span>`);
        } else if (this.packBuilderTitle && this.packBuilderTitle.querySelector("span.size") != null) {
          this.packBuilderTitle.querySelector("span.size").innerHTML = this.size;
        }
      }

      renderProducts() {
        const templates = this.querySelectorAll("template");
        if (!templates) return;

        this.gridContainer.innerHTML = ""; // Nettoie le contenu existant
        templates.forEach((template) => {
          this.products.forEach((product) => {
            if (product.id === template.getAttribute("product-id")) {
              const clone = document.importNode(template.content, true);
              const productCard = clone.querySelector(".product_card");
              productCard.setAttribute("data-id", product.id);
              productCard.querySelector("img").src = product.featured_image;
              productCard.querySelector("img").alt = product.title;
              productCard.querySelector(".hotnailmainprdthx_slider_item_title").textContent = product.title;
              this.gridContainer.appendChild(clone);
            }
          });
        });
      }

      handleSuperiorOfferProperties(e) {
        this.previousProperties = e.detail.properties;
      }

      applyPreviousProperties() {
        Object.entries(this.previousProperties).forEach(([name, quantity]) => {
          const card = this.gridContainer.querySelector(`.product_card[data-name="${name}"]`);
          if (card) {
            card.classList.add("active");
            card.querySelector(".selected_number").textContent = quantity;

            // Ajouter le produit à productsSelected en fonction de la quantité
            for (let i = 0; i < parseInt(quantity); i++) {
              this.productsSelected.push(card.getAttribute("data-id"));
            }
          }
        });

        // Mettre à jour le formulaire et l'état des éléments
        this.updateFormInputs();
        this.handleGridState(this.productsSelected.length);
        this.handleInfoContainer(this.productsSelected.length);
      }

      addEventListeners() {
        this.gridContainer.addEventListener("click", (e) => {
          if (e.target.closest(".product_add")) {
            this.addProduct(e.target.closest(".product_card"));
          } else if (e.target.closest(".plus")) {
            this.incrementProduct(e.target.closest(".product_card"));
          } else if (e.target.closest(".minus")) {
            this.removeProduct(e.target.closest(".product_card"));
          } else if (e.target.closest(".product-info-bubble_pack")) {
            this.showPopup(e.target.closest(".product_card"));
          } else if (e.target.closest(".hotnailmainprdthx_slider_item_image img")) {
            // Ajouter un événement de clic sur l'image pour incrémenter la quantité
            this.handleImageClick(e.target.closest(".product_card"));
          }
        });

        if (this.closePopup) {
          this.closePopup.addEventListener("click", () => {
            this.popup.style.display = "none";
          });
        }

        this.popup?.addEventListener("click", (event) => {
          if (event.target === this.popup) {
            this.popup.style.display = "none";
          }
        });
      }

      addProduct(card) {
        // Vérifier strictement par rapport à la limite maximale
        if (this.productsSelected.length < this.maxLimit) {
          card.classList.add("active");
          this.productsSelected.push(card.getAttribute("data-id"));
          this.updateState(card);
          this.updateFormInputs();
        } else {
          // Notification optionnelle quand la limite est atteinte
          this.showLimitReachedNotification();
        }
      }

      incrementProduct(card) {
        // Vérifier strictement par rapport à la limite maximale
        if (this.productsSelected.length < this.maxLimit) {
          this.productsSelected.push(card.getAttribute("data-id"));
          this.updateState(card, "add");
          this.updateFormInputs();
        } else {
          // Notification optionnelle quand la limite est atteinte
          this.showLimitReachedNotification();
        }
        this.handleGridState(this.productsSelected.length);
        this.handleInfoContainer(this.productsSelected.length);
      }

      handleInfoContainer(productsSelectedLength) {
        const text_count = this.getAttribute("data-text-count");
        const text_completed = this.getAttribute("data-text-completed");
        if (productsSelectedLength >= this.maxLimit) {
          this.infoContainer.classList.add("completed");
          this.textElement.innerHTML = text_completed;
        } else {
          this.infoContainer.classList.remove("completed");
          this.textElement.innerHTML = text_count.replace("||count||", parseInt(this.maxLimit) - parseInt(productsSelectedLength));
        }
      }

      handleGridState(productsSelectedLength) {
        if (productsSelectedLength >= this.maxLimit) {
          this.gridContainer.classList.add("complete");
        } else {
          this.gridContainer.classList.remove("complete");
        }
      }

      removeProduct(card) {
        const productId = card.getAttribute("data-id");
        const index = this.productsSelected.indexOf(productId);

        if (index > -1) {
          // Retirer uniquement une occurrence du produit sélectionné
          this.productsSelected.splice(index, 1);
          this.updateState(card, "remove");
          this.updateFormInputs();
        }
      }

      updateState(card, action = "add") {
        const selectedNumber = card.querySelector(".selected_number");
        let currentQuantity = parseInt(selectedNumber.textContent);

        if (action === "add") {
          currentQuantity += 1;
          selectedNumber.textContent = currentQuantity;

          // Animation brève pour indiquer l'ajout (similaire à BoostEcom)
          card.classList.add("flash-highlight");
          setTimeout(() => {
            card.classList.remove("flash-highlight");
          }, 300);
        } else if (action === "remove") {
          currentQuantity -= 1;
          selectedNumber.textContent = currentQuantity;

          if (currentQuantity <= 0) {
            card.classList.remove("active");
          }
        }

        // Désactiver le bouton "Ajouter au panier" si la limite n'est pas atteinte
        this.btnAddToCart.disabled = this.productsSelected.length < this.maxLimit;
        this.handleGridState(this.productsSelected.length);
        this.handleInfoContainer(this.productsSelected.length);
      }

      updateFormInputs() {
        const form = this.parent.querySelector(`#${this.getAttribute("data-form-id")}`);
        if (!form) return;

        // Supprimer les inputs existants
        form.querySelectorAll(".myinput").forEach((input) => input.remove());

        // Compter les occurrences de chaque produit sélectionné
        const productCounts = {};
        this.productsSelected.forEach((productId) => {
          productCounts[productId] = (productCounts[productId] || 0) + 1;
        });

        // Ajouter les nouveaux inputs avec les quantités correspondantes
        Object.entries(productCounts).forEach(([productId, count]) => {
          const product = this.products.find((p) => p.id === productId);
          if (product) {
            let newInput = document.createElement("input");
            newInput.type = "hidden";
            newInput.name = `properties[${product.title}]`;
            newInput.classList.add("myinput");
            newInput.id = `id${product.id}`;
            newInput.value = count;
            form.appendChild(newInput);
          }
        });
      }

      showPopup(card) {
        const productDescription = card.querySelector(".product-description")?.innerHTML;
        if (this.popup && this.popupContent && productDescription) {
          this.popupContent.innerHTML = productDescription;
          this.popup.style.display = "flex";
        }
      }

      updateQuantities(oldList, newList) {
        // Compter les occurrences des produits dans newList
        let newCount = {};
        newList.forEach((productId) => {
          newCount[productId] = (newCount[productId] || 0) + 1;
        });

        // Mettre à jour les cartes pour les produits retirés
        oldList.forEach((productId) => {
          if (!newCount[productId]) {
            // Si le produit n'est pas dans newList, il a été retiré
            let card = this.gridContainer.querySelector(`.product_card[data-id="${productId}"]`);
            if (card) {
              this.updateState(card, "remove");
            }
          }
        });

        // Mettre à jour les cartes pour les produits conservés
        Object.entries(newCount).forEach(([productId, count]) => {
          let card = this.gridContainer.querySelector(`.product_card[data-id="${productId}"]`);
          if (card) {
            card.classList.add("active");
            card.querySelector(".selected_number").textContent = count;
          }
        });

        // Désactiver le bouton "Ajouter au panier" si la limite n'est pas atteinte
        this.handleGridState(newList.length);
        this.handleInfoContainer(newList.length);
        this.btnAddToCart.disabled = newList.length < this.size;
      }

      initVariantChangeListener() {
        if (!this.variants) return;

        let newLimit = this.size;
        this.btnAddToCart.disabled = true;

        document.addEventListener("variant:change", (e) => {
          if (!e.detail.variant) return;

          console.log("Événement variant:change détecté:", e.detail.variant);

          // Trouver la variante correspondante dans nos données
          const selectedVariant = this.variants.find((v) => v.id == e.detail.variant.id);

          if (selectedVariant) {
            console.log("Variante sélectionnée dans nos données:", selectedVariant);

            // 1. Vérifier si la variante a une limite spécifique
            if (selectedVariant.limit) {
              newLimit = parseInt(selectedVariant.limit);
              console.log(`Nouvelle limite à partir de la variante: ${newLimit}`);
            }
            // 2. Sinon, utiliser la limite de l'attribut data-limit
            else {
              newLimit = parseInt(this.getAttribute("data-limit")) || this.size;
              console.log(`Utilisation de la limite par défaut: ${newLimit}`);
            }
          } else {
            console.warn(`Variante non trouvée dans nos données: ${e.detail.variant.id}`);
            // Fallback à la limite par défaut
            newLimit = parseInt(this.getAttribute("data-limit")) || this.size;
          }

          // Mettre à jour la limite maximale
          this.maxLimit = newLimit;
          this.size = newLimit;
          console.log(`Limite mise à jour: ${this.maxLimit}`);
          this.updateTitle();

          // Cloner l'ancienne sélection
          this.oldProductsSelected = [...this.productsSelected];

          // Ajuster la sélection en fonction de la nouvelle limite
          if (this.productsSelected.length > this.maxLimit) {
            console.log(`Ajustement de la sélection: ${this.productsSelected.length} -> ${this.maxLimit}`);
            this.productsSelected.splice(this.maxLimit, this.productsSelected.length - this.maxLimit);
          }

          // Mettre à jour les quantités et l'état des cartes
          this.updateQuantities(this.oldProductsSelected, this.productsSelected);
          this.updateFormInputs();
        });
      }

      // Nouvelle méthode pour gérer le clic sur l'image
      handleImageClick(card) {
        // Si la carte n'est pas encore active, ajouter le produit
        if (!card.classList.contains("active")) {
          // Ajouter le produit et activer la carte
          // Vérifier si nous pouvons ajouter par rapport à la limite maximale
          if (this.productsSelected.length < this.maxLimit) {
            card.classList.add("active");
            this.productsSelected.push(card.getAttribute("data-id"));
            this.updateState(card);
            this.updateFormInputs();
          } else {
            this.showLimitReachedNotification();
          }
        }
        // Sinon, incrémenter la quantité si la limite n'est pas atteinte
        else if (this.productsSelected.length < this.maxLimit) {
          // Tenter de récupérer l'incrément depuis un attribut data-increment
          // Cela permet la compatibilité avec l'approche de BoostEcom
          const incrementStep = parseInt(card.getAttribute("data-increment")) || 1;

          // Incrémenter uniquement si nous ne dépassons pas la limite
          const remainingSpace = this.maxLimit - this.productsSelected.length;
          const actualIncrement = Math.min(incrementStep, remainingSpace);

          if (actualIncrement > 0) {
            // Ajouter le produit autant de fois que possible sans dépasser la limite
            for (let i = 0; i < actualIncrement; i++) {
              this.productsSelected.push(card.getAttribute("data-id"));
            }
            // Mettre à jour l'état de la carte
            this.updateState(card, "add");
            this.updateFormInputs();
          } else {
            this.showLimitReachedNotification();
          }
        } else {
          this.showLimitReachedNotification();
        }

        // Mettre à jour l'état visuel et l'interface
        this.handleGridState(this.productsSelected.length);
        this.handleInfoContainer(this.productsSelected.length);
      }

      // Méthode pour notifier l'utilisateur quand la limite est atteinte
      showLimitReachedNotification() {
        // Créer une notification temporaire
        const notification = document.createElement("div");
        notification.className = "limit-notification";
        notification.textContent = `Vous avez atteint la limite de ${this.maxLimit} produits`;

        // Ajouter au DOM
        document.body.appendChild(notification);

        // Animation d'entrée
        setTimeout(() => {
          notification.classList.add("visible");
        }, 10);

        // Disparaître après 3 secondes
        setTimeout(() => {
          notification.classList.remove("visible");
          // Supprimer après la fin de l'animation
          setTimeout(() => {
            notification.remove();
          }, 300);
        }, 3000);
      }

      // Méthode pour styliser les options de variante
      stylizeVariantOptions() {
        // Attendre que les données soient chargées
        if (!this.variants || this.variants.length === 0) {
          // Si les variants ne sont pas encore chargés, réessayer plus tard
          setTimeout(() => this.stylizeVariantOptions(), 100);
          return;
        }

        // Classes à appliquer
        const applyStylesToSelectors = () => {
          // Rechercher différents types de sélecteurs de variantes
          const selectors = [".single-option-selector", ".product-form__variants", ".product-options", 'fieldset[name="id"]'];

          // Trouver tous les conteneurs de sélecteurs
          const selectorContainers = document.querySelectorAll(selectors.join(", "));

          if (selectorContainers.length === 0) {
            // Si les éléments ne sont pas encore disponibles, réessayer plus tard
            setTimeout(applyStylesToSelectors, 200);
            return;
          }

          // Pour chaque conteneur, trouver les options et appliquer les styles
          selectorContainers.forEach((container) => {
            // Chercher les options ou boutons radio
            const options = container.querySelectorAll('option, input[type="radio"]');

            options.forEach((option) => {
              const optionId = option.value;
              // Trouver la variante correspondante
              const variant = this.variants.find((v) => v.id === optionId);

              if (variant) {
                let targetElement;

                if (option.tagName === "OPTION") {
                  // Pour les options de menu déroulant, styliser l'option et son conteneur
                  option.classList.toggle("popular", variant.populaire && variant.populaire.toLowerCase() === "populaire");
                  targetElement = option.closest(".selector-wrapper") || container;
                } else {
                  // Pour les boutons radio, styliser le label
                  targetElement = document.querySelector(`label[for="${option.id}"]`) || option.parentElement;
                }

                if (targetElement) {
                  // Appliquer les classes
                  if (variant.populaire && variant.populaire.toLowerCase() === "populaire") {
                    targetElement.classList.add("popular");
                  }

                  // Si c'est l'option sélectionnée
                  if (option.selected || option.checked) {
                    targetElement.classList.add("selected");
                  }
                }
              }
            });
          });

          // Styliser le sélecteur actuellement sélectionné
          const currentVariantId = document.querySelector('select[name="id"]')?.value || document.querySelector('input[name="id"]:checked')?.value;

          if (currentVariantId) {
            const currentVariant = this.variants.find((v) => v.id === currentVariantId);
            if (currentVariant && currentVariant.populaire && currentVariant.populaire.toLowerCase() === "populaire") {
              // S'assurer que la variante populaire est sélectionnée initialement
              const selector =
                document.querySelector(`select[name="id"] option[value="${currentVariantId}"]`) ||
                document.querySelector(`input[name="id"][value="${currentVariantId}"]`);

              if (selector) {
                const wrapper = selector.closest(".selector-wrapper") || document.querySelector(`label[for="${selector.id}"]`) || selector.parentElement;

                if (wrapper) {
                  wrapper.classList.add("selected");
                  wrapper.classList.add("popular");
                }
              }
            }
          }
        };

        // Lancer la première application de styles
        applyStylesToSelectors();

        // Ajouter un écouteur pour mettre à jour les styles lors du changement de variante
        document.addEventListener("variant:change", (e) => {
          // Enlever la classe selected de tous les éléments
          document.querySelectorAll(".selector-wrapper.selected, label.selected").forEach((el) => {
            el.classList.remove("selected");
          });

          // Ajouter la classe selected à l'élément sélectionné
          if (e.detail.variant) {
            const variantId = e.detail.variant.id;
            const selectedOption = document.querySelector(`option[value="${variantId}"]`) || document.querySelector(`input[value="${variantId}"]`);

            if (selectedOption) {
              const wrapper =
                selectedOption.closest(".selector-wrapper") || document.querySelector(`label[for="${selectedOption.id}"]`) || selectedOption.parentElement;

              if (wrapper) {
                wrapper.classList.add("selected");
              }
            }
          }
        });
      }

      // Méthode pour styliser les variantes populaires (sans les sélectionner)
      selectPopularVariant() {
        if (!this.variants || this.variants.length === 0) {
          console.log("Aucune variante disponible pour le style populaire.");
          return;
        }

        // Log de débogage pour voir toutes les variantes
        console.log("Recherche de variante populaire parmi:", this.variants);

        // Trouver la variante marquée comme populaire (insensible à la casse)
        const popularVariant = this.variants.find((v) => v.populaire && v.populaire.toLowerCase() === "populaire");

        if (popularVariant) {
          console.log("Variante populaire trouvée:", popularVariant.id);

          // Appliquer uniquement le style visuel pour la variante populaire
          // sans la sélectionner automatiquement
          setTimeout(() => {
            const variantSelectors = {
              select: document.querySelector(`select[name="id"] option[value="${popularVariant.id}"]`),
              radio: document.querySelector(`input[name="id"][value="${popularVariant.id}"]`),
            };

            console.log("Sélecteurs trouvés:", variantSelectors);

            if (variantSelectors.select) {
              const parentSelect = variantSelectors.select.closest(".selector-wrapper");
              if (parentSelect) {
                parentSelect.classList.add("popular");
                console.log('Classe "popular" ajoutée au sélecteur parent');

                // Ajouter le badge "Populaire" en tant qu'élément visuel si nécessaire
                if (!parentSelect.querySelector(".popular-badge")) {
                  const badge = document.createElement("div");
                  badge.className = "popular-badge badge-populaire-forced";
                  badge.textContent = "Populaire";
                  badge.style.position = "absolute";
                  badge.style.top = "-10px";
                  badge.style.right = "10px";
                  badge.style.backgroundColor = "#e74c3c";
                  badge.style.color = "white";
                  badge.style.padding = "2px 8px";
                  badge.style.borderRadius = "10px";
                  badge.style.fontSize = "12px";
                  badge.style.fontWeight = "bold";
                  badge.style.zIndex = "100";
                  badge.style.display = "block";
                  parentSelect.style.position = "relative";
                  parentSelect.appendChild(badge);
                  console.log('Badge "Populaire" ajouté au sélecteur parent');
                }
              }

              // Styliser l'option elle-même
              variantSelectors.select.classList.add("popular");
            }

            if (variantSelectors.radio) {
              // Obtenir le parent immédiat et tous les parents potentiels
              const radioElement = variantSelectors.radio;
              const possibleContainers = [
                document.querySelector(`label[for="${radioElement.id}"]`),
                radioElement.closest(".variant-input"),
                radioElement.parentElement,
                radioElement.parentElement?.parentElement, // Remonter au parent du parent si nécessaire
              ].filter((el) => el); // Filtrer les éléments null/undefined

              console.log("Conteneurs possibles pour radio:", possibleContainers);

              // Appliquer le style au premier conteneur valide ou directement au radio si aucun n'est trouvé
              const container = possibleContainers[0] || radioElement;

              container.classList.add("popular");
              console.log('Classe "popular" ajoutée à:', container);

              // Si le conteneur est le radio lui-même, styliser différemment
              if (container === radioElement) {
                // Créer un wrapper autour du radio pour le badge
                const wrapper = document.createElement("div");
                wrapper.className = "radio-badge-wrapper";
                wrapper.style.position = "relative";
                wrapper.style.display = "inline-block";

                // Insérer le wrapper à la place du radio
                radioElement.parentNode.insertBefore(wrapper, radioElement);
                wrapper.appendChild(radioElement);

                // Ajouter le badge au wrapper
                const badge = document.createElement("div");
                badge.className = "popular-badge badge-populaire-forced";
                badge.textContent = "Populaire";
                badge.style.position = "absolute";
                badge.style.top = "-15px";
                badge.style.right = "0";
                badge.style.backgroundColor = "#e74c3c";
                badge.style.color = "white";
                badge.style.padding = "2px 8px";
                badge.style.borderRadius = "10px";
                badge.style.fontSize = "12px";
                badge.style.fontWeight = "bold";
                badge.style.zIndex = "100";
                badge.style.display = "block";
                wrapper.appendChild(badge);
                console.log('Badge "Populaire" ajouté au wrapper de radio');
              } else {
                // Ajouter le badge "Populaire" au conteneur normal
                if (!container.querySelector(".popular-badge")) {
                  container.style.position = "relative";
                  const badge = document.createElement("div");
                  badge.className = "popular-badge badge-populaire-forced";
                  badge.textContent = "Populaire";
                  badge.style.position = "absolute";
                  badge.style.top = "-10px";
                  badge.style.right = "10px";
                  badge.style.backgroundColor = "#e74c3c";
                  badge.style.color = "white";
                  badge.style.padding = "2px 8px";
                  badge.style.borderRadius = "10px";
                  badge.style.fontSize = "12px";
                  badge.style.fontWeight = "bold";
                  badge.style.zIndex = "100";
                  badge.style.display = "block";
                  container.appendChild(badge);
                  console.log('Badge "Populaire" ajouté au conteneur:', container);
                }
              }
            }

            // Appliquer le style directement sur les sélecteurs de variantes personnalisées
            const customSelectors = document.querySelectorAll(".variant-input-wrap label, .variant-input");
            customSelectors.forEach((selector) => {
              const input = selector.querySelector('input[type="radio"]');
              if (input && input.value === popularVariant.id) {
                selector.classList.add("popular");

                // Ajouter le badge "Populaire" directement sur les sélecteurs personnalisés
                if (!selector.querySelector(".popular-badge")) {
                  const badge = document.createElement("span");
                  badge.className = "popular-badge badge-populaire-forced";
                  badge.textContent = "Populaire";
                  badge.style.position = "absolute";
                  badge.style.top = "-10px";
                  badge.style.right = "10px";
                  badge.style.backgroundColor = "#e74c3c";
                  badge.style.color = "white";
                  badge.style.padding = "2px 8px";
                  badge.style.borderRadius = "10px";
                  badge.style.fontSize = "12px";
                  badge.style.fontWeight = "bold";
                  badge.style.zIndex = "100";
                  badge.style.display = "block";
                  selector.style.position = "relative";
                  selector.appendChild(badge);
                  console.log('Badge "Populaire" ajouté au sélecteur personnalisé');
                }
              }
            });

            console.log('Style "populaire" appliqué visuellement.');
          }, 1000); // Augmenter le délai pour s'assurer que le DOM est prêt
        } else {
          console.log("Aucune variante marquée comme populaire.");
        }
      }
    }
  );
}

// Fonction pour injecter des styles CSS directement dans la page
function injectStyles() {
  const styleElement = document.createElement("style");
  styleElement.textContent = `
    .badge-populaire-forced {
      position: absolute !important;
      top: -10px !important;
      right: 10px !important;
      background-color: #e74c3c !important;
      color: white !important;
      padding: 2px 8px !important;
      border-radius: 10px !important;
      font-size: 12px !important;
      font-weight: bold !important;
      z-index: 9999 !important;
      display: block !important;
      pointer-events: none !important;
    }
    
    .radio-badge-wrapper {
      position: relative !important;
      display: inline-block !important;
      border: 1px solid #e74c3c !important;
      padding: 2px !important;
      margin: 2px !important;
      border-radius: 3px !important;
    }
    
    input[type="radio"].popular + label,
    label.popular {
      border: 1px solid #e74c3c !important;
      position: relative !important;
    }
    
    /* Styles spécifiques pour divers thèmes Shopify */
    .selector-wrapper.popular,
    .variant-input.popular, 
    .swatch-element.popular,
    .variant__button-label.popular {
      position: relative !important;
      border: 1px solid #e74c3c !important;
    }
  `;
  document.head.appendChild(styleElement);
  console.log("Styles CSS injectés dans la page");
}

// Appliquer les styles dès que possible
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", injectStyles);
} else {
  injectStyles();
}

// Fonction pour appliquer manuellement les badges populaires sur la page
document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function () {
    // Tenter d'obtenir les variantes populaires à partir du script JSON dans le DOM
    const variantsDataElement = document.getElementById("variants-data");
    if (variantsDataElement) {
      try {
        const variantsData = JSON.parse(variantsDataElement.textContent);
        const popularVariants = variantsData.filter((v) => v.populaire && v.populaire.toLowerCase() === "populaire");

        if (popularVariants.length > 0) {
          console.log("Application manuelle des badges populaires pour:", popularVariants);

          // Créer un badge global en position absolue qui sera visible quel que soit le thème
          createGlobalPopularBadge(popularVariants[0].id);

          // Chercher tous les sélecteurs possibles pour ces variantes
          popularVariants.forEach((variant) => {
            // Recherche de tous les éléments qui pourraient contenir cette variante
            [
              `select[name="id"] option[value="${variant.id}"]`,
              `input[name="id"][value="${variant.id}"]`,
              `.variant-input-wrap input[value="${variant.id}"]`,
              `.variant-input[data-value="${variant.id}"]`,
            ].forEach((selector) => {
              const elements = document.querySelectorAll(selector);

              elements.forEach((element) => {
                // Identifier le conteneur parent
                let container = null;

                if (element.tagName === "OPTION") {
                  container = element.closest(".selector-wrapper") || element.closest("select").parentElement;
                } else if (element.tagName === "INPUT") {
                  // Liste des conteneurs potentiels pour les inputs radio
                  const possibleContainers = [
                    document.querySelector(`label[for="${element.id}"]`),
                    element.closest(".variant-input"),
                    element.parentElement,
                    element.parentElement?.parentElement,
                  ].filter((el) => el);

                  container = possibleContainers[0];
                }

                // Si aucun conteneur n'est trouvé et que c'est un input, créer un wrapper
                if (!container && element.tagName === "INPUT") {
                  // Créer un wrapper autour de l'input
                  const wrapper = document.createElement("div");
                  wrapper.className = "radio-badge-wrapper";
                  wrapper.style.position = "relative";
                  wrapper.style.display = "inline-block";
                  wrapper.style.border = "1px solid #e74c3c";

                  // Insérer le wrapper à la place de l'input
                  element.parentNode.insertBefore(wrapper, element);
                  wrapper.appendChild(element);

                  // Utiliser le wrapper comme conteneur
                  container = wrapper;
                  console.log("Wrapper créé pour l'élément:", element);
                }

                if (container) {
                  // S'assurer que le conteneur a une position relative
                  container.style.position = "relative";
                  container.style.border = "1px solid #e74c3c";

                  // Créer et ajouter le badge si nécessaire
                  if (!container.querySelector(".badge-populaire-forced")) {
                    const badge = document.createElement("div");
                    badge.className = "badge-populaire-forced";
                    badge.textContent = "Populaire";

                    // Ajuster la position pour les wrappers créés
                    if (container.classList.contains("radio-badge-wrapper")) {
                      badge.style.top = "-15px";
                      badge.style.right = "0";
                    }

                    container.appendChild(badge);
                    console.log("Badge populaire appliqué manuellement à:", container);
                  }
                } else {
                  console.warn("Aucun conteneur trouvé pour appliquer le badge à:", element);
                }
              });
            });
          });
        }
      } catch (error) {
        console.error("Erreur lors de l'application manuelle des badges populaires:", error);
      }
    }
  }, 2000); // Délai suffisant pour que les éléments du thème soient chargés
});

// Fonction pour créer un badge global qui sera visible quel que soit le thème
function createGlobalPopularBadge(variantId) {
  // Rechercher tous les éléments possibles liés à cette variante
  const selectors = [
    `select[name="id"] option[value="${variantId}"]`,
    `input[name="id"][value="${variantId}"]`,
    `.variant-input-wrap input[value="${variantId}"]`,
    `.variant-input[data-value="${variantId}"]`,
  ];

  let targetElement = null;

  // Essayer de trouver un élément
  for (const selector of selectors) {
    const element = document.querySelector(selector);
    if (element) {
      targetElement = element;
      break;
    }
  }

  if (!targetElement) {
    console.warn("Aucun élément trouvé pour le badge global de la variante", variantId);
    return;
  }

  // Trouver la section des variantes
  let variantContainer = null;
  const possibleContainers = [
    ".variant-wrapper",
    ".variant-input-wrap",
    ".selector-wrapper",
    ".product-form__variants",
    'fieldset[name="id"]',
    ".radio-wrapper",
    ".product-single__variants",
  ];

  for (const containerSelector of possibleContainers) {
    const container = document.querySelector(containerSelector);
    if (container) {
      variantContainer = container;
      break;
    }
  }

  if (!variantContainer) {
    console.warn("Aucun conteneur de variantes trouvé pour le badge global");
    return;
  }

  // S'assurer que le conteneur est en position relative
  variantContainer.style.position = "relative";

  // Créer une div flottante qui mettra en évidence la variante populaire
  const highlightDiv = document.createElement("div");
  highlightDiv.className = "global-popular-highlight";
  highlightDiv.style.cssText = `
    position: absolute;
    z-index: 9998;
    display: block;
    pointer-events: none;
    border: 2px solid #e74c3c;
    border-radius: 5px;
    padding: 5px;
    box-shadow: 0 0 0 2px rgba(231, 76, 60, 0.3);
  `;

  // Créer le badge
  const badge = document.createElement("div");
  badge.className = "global-popular-badge badge-populaire-forced";
  badge.textContent = "Populaire";
  badge.style.cssText = `
    position: absolute;
    top: -15px;
    left: 50%;
    transform: translateX(-50%);
    background-color: #e74c3c;
    color: white;
    padding: 2px 8px;
    border-radius: 10px;
    font-size: 12px;
    font-weight: bold;
    z-index: 9999;
    display: block;
    pointer-events: none;
  `;

  // Observer les changements dans le DOM pour repositionner le surlignage
  const observer = new MutationObserver(function () {
    positionHighlight();
  });

  observer.observe(document.body, {
    attributes: true,
    childList: true,
    subtree: true,
  });

  // Positionner le surlignage
  function positionHighlight() {
    // Rechercher à nouveau l'élément car il pourrait avoir changé
    const element =
      document.querySelector(`input[name="id"][value="${variantId}"]`) || document.querySelector(`select[name="id"] option[value="${variantId}"]`);

    if (!element) return;

    // Obtenir le conteneur parent approprié
    let container;
    if (element.tagName === "OPTION") {
      container = element.closest("select");
    } else if (element.type === "radio") {
      container = document.querySelector(`label[for="${element.id}"]`) || element.closest(".variant-input") || element.parentElement;
    }

    if (!container) return;

    // Obtenir la position et les dimensions
    const rect = container.getBoundingClientRect();

    // Positionner le surlignage
    highlightDiv.style.top = `${rect.top + window.scrollY - 10}px`;
    highlightDiv.style.left = `${rect.left + window.scrollX - 10}px`;
    highlightDiv.style.width = `${rect.width + 20}px`;
    highlightDiv.style.height = `${rect.height + 20}px`;
  }

  // Positionner initialement
  setTimeout(positionHighlight, 500);

  // Ajouter les éléments au DOM
  document.body.appendChild(highlightDiv);
  highlightDiv.appendChild(badge);

  console.log('Badge global "Populaire" créé pour la variante', variantId);
}

// Fonction pour créer un badge sur l'interface visuelle des packs
function highlightVisualPackOption(variantId) {
  try {
    console.log("🎯 DÉBUT highlightVisualPackOption pour variantId:", variantId);
    console.log(
      "🔍 DOM actuel - options visibles:",
      document.querySelectorAll('.block-with-info--v3, [data-variant-id], input[name="id"], option[value]').length
    );

    // Récupérer les données de la variante populaire
    const variantsDataElement = document.getElementById("variants-data");
    if (!variantsDataElement) return;

    const variantsData = JSON.parse(variantsDataElement.textContent);
    const popularVariant = variantsData.find((v) => v.id === variantId);

    if (!popularVariant) {
      console.warn("Impossible de trouver les données de la variante populaire");
      return;
    }

    console.log("Données de la variante populaire:", popularVariant);

    // Extraire le nombre de parfums à partir de la limite
    const packSize = parseInt(popularVariant.limit) || 4; // Par défaut 4 si non défini
    console.log("Taille du pack populaire:", packSize);

    // Nettoyer TOUS les badges indésirables (bordures rouges, flottants, etc.)
    document.querySelectorAll(".floating-popular-badge, .badge-populaire-forced, .popular-badge, .radio-badge-wrapper").forEach((badge) => {
      badge.remove();
    });

    // Supprimer les bordures rouges sur les éléments
    document.querySelectorAll('.popular, [style*="border"]').forEach((element) => {
      element.classList.remove("popular");
      if (element.style.border) {
        element.style.border = "";
      }
    });

    // ===== MÉTHODE 1: Recherche du badge natif du thème Shopify =====
    // Plusieurs sélecteurs possibles pour les badges dans les thèmes Shopify
    const badgeSelectors = [".block-with-info--v3__badge", ".product-badge", ".badge", ".tag", '[class*="badge"]', '[class*="tag"]', ".popularity-label"];

    // Sélectionneurs pour les conteneurs d'options ou de variantes
    const containerSelectors = [
      ".bundle-option",
      ".product-form__option",
      ".variant-option",
      ".block-with-info--v3",
      ".single-option-selector",
      ".option-selector",
      "[data-variant-id]",
    ];

    // 1.1 Trouver le badge natif visible ou un badge caché pour cette variante
    const allBadgeElements = document.querySelectorAll(badgeSelectors.join(","));
    console.log("Badges natifs trouvés:", allBadgeElements.length);

    // Essayer d'abord de trouver un badge déjà associé à cette variante
    let variantSpecificBadge = null;

    // Parcourir tous les conteneurs d'options ou de variantes
    document.querySelectorAll(containerSelectors.join(",")).forEach((container) => {
      // Vérifier si ce conteneur correspond EXACTEMENT à notre variante
      if (container.getAttribute("data-variant-id") === variantId || container.querySelector(`[value="${variantId}"]`)) {
        // Chercher un badge à l'intérieur
        const badgeInContainer = container.querySelector(badgeSelectors.join(","));
        if (badgeInContainer) {
          console.log("✅ Badge trouvé dans le conteneur EXACT de la variante populaire:", badgeInContainer);
          variantSpecificBadge = badgeInContainer;
        }
      } else {
        // S'assurer qu'aucun autre conteneur n'a de badge "Populaire"
        const badgeInContainer = container.querySelector(badgeSelectors.join(","));
        if (badgeInContainer && badgeInContainer.textContent && badgeInContainer.textContent.toLowerCase().includes("populaire")) {
          console.log("🧹 Suppression badge populaire d'un autre conteneur:", container);
          badgeInContainer.classList.add("block-with-info--v3__badge--hidden");
          badgeInContainer.style.display = "none";
        }
      }
    });

    // Si on a trouvé un badge spécifique, l'utiliser
    if (variantSpecificBadge) {
      console.log("✅ MÉTHODE 1 RÉUSSIE - Badge natif spécifique trouvé:", variantSpecificBadge);

      // Retirer les classes qui pourraient cacher le badge
      variantSpecificBadge.classList.remove("block-with-info--v3__badge--hidden", "hidden", "hide");

      // Mettre à jour le contenu et le style avec protection permanente
      variantSpecificBadge.textContent = "Populaire";
      variantSpecificBadge.style.display = "block";
      variantSpecificBadge.style.visibility = "visible";
      variantSpecificBadge.style.opacity = "1";
      variantSpecificBadge.style.border = "none"; // Supprimer toute bordure
      variantSpecificBadge.classList.add("badge-permanent"); // Marquer comme permanent

      console.log("🎉 Badge spécifique activé avec succès et protection permanente ajoutée");
      return; // On a trouvé un badge parfait, on s'arrête là
    }

    // 1.2 Si aucun badge spécifique n'a été trouvé, chercher n'importe quel badge natif
    const firstVisibleBadge = document.querySelector(".block-with-info--v3__badge:not(.block-with-info--v3__badge--hidden)");
    const firstHiddenBadge = document.querySelector(".block-with-info--v3__badge.block-with-info--v3__badge--hidden");
    const anyBadge = firstVisibleBadge || firstHiddenBadge || document.querySelector(badgeSelectors.join(","));

    if (anyBadge) {
      console.log("✅ MÉTHODE 1B RÉUSSIE - Badge natif général trouvé:", anyBadge);

      // Retirer les classes qui pourraient cacher le badge
      anyBadge.classList.remove("block-with-info--v3__badge--hidden", "hidden", "hide");

      // Mettre à jour le contenu
      const badgeSpan = anyBadge.querySelector("span") || anyBadge;
      badgeSpan.textContent = "Populaire";

      // Assurer la visibilité et ajouter protection permanente
      anyBadge.style.display = "flex";
      anyBadge.style.visibility = "visible";
      anyBadge.style.opacity = "1";
      anyBadge.style.border = "none"; // Supprimer toute bordure
      anyBadge.classList.add("badge-permanent"); // Marquer comme permanent

      console.log("🎉 Badge natif général activé avec succès et protection permanente ajoutée");
      return; // On a réussi avec un badge natif général
    }

    // ===== MÉTHODE 2: Ciblage intelligent par taille de pack =====
    console.log("⚡ MÉTHODE 2 - Ciblage intelligent par taille de pack:", packSize);

    // Rechercher des textes avec la taille du pack (plus robuste)
    const packSizeTexts = [`${packSize} parfums`, `${packSize} fragrances`, `${packSize} produits`];

    for (const sizeText of packSizeTexts) {
      // Trouver tous les éléments qui contiennent ce texte
      const elementsWithText = Array.from(document.querySelectorAll("*")).filter((el) => {
        return el.textContent && el.textContent.trim() === sizeText;
      });

      console.log(`Éléments avec texte "${sizeText}" trouvés:`, elementsWithText.length);

      for (const element of elementsWithText) {
        // Remonter pour trouver le conteneur de l'option
        let container = element;
        for (let i = 0; i < 5 && container; i++) {
          // Si nous trouvons un conteneur approprié
          if (container.matches(containerSelectors.join(","))) {
            console.log("Conteneur d'option trouvé:", container);

            // Vérifier si ce conteneur a une position relative/absolute
            const position = window.getComputedStyle(container).position;
            if (position === "static") {
              container.style.position = "relative";
            }

            // Créer notre badge personnalisé
            const customBadge = document.createElement("div");
            customBadge.className = "badge-populaire-forced block-with-info--v3__badge";
            customBadge.textContent = "Populaire";
            customBadge.style.cssText = `
              position: absolute;
              top: -10px;
              right: 10px;
              background-color: #e74c3c;
              color: white;
              padding: 5px 10px;
              border-radius: 3px;
              font-size: 12px;
              font-weight: bold;
              z-index: 100;
              display: block;
            `;

            container.appendChild(customBadge);
            console.log("✅ MÉTHODE 2 RÉUSSIE - Badge personnalisé ajouté au conteneur");
            return; // Succès!
          }

          container = container.parentElement;
        }
      }
    }

    // ===== MÉTHODE 3: Badge flottant si tout échoue =====
    console.warn("❌ TOUTES LES MÉTHODES ONT ÉCHOUÉ - Création d'un badge flottant de secours");

    // Créer un badge flottant comme solution de dernier recours
    const floatingBadge = document.createElement("div");
    floatingBadge.className = "floating-popular-badge";
    floatingBadge.textContent = `Pack ${packSize} parfums : Populaire`;
    floatingBadge.style.cssText = `
      position: fixed;
      top: 80px;
      right: 20px;
      background-color: #e74c3c;
      color: white;
      padding: 10px 15px;
      border-radius: 5px;
      font-size: 14px;
      font-weight: bold;
      z-index: 9999;
      box-shadow: 0 2px 10px rgba(0,0,0,0.2);
    `;

    document.body.appendChild(floatingBadge);
    console.log("Badge flottant ajouté comme solution de secours");

    // Le supprimer après 10 secondes
    setTimeout(() => {
      if (document.body.contains(floatingBadge)) {
        floatingBadge.remove();
      }
    }, 10000);
  } catch (error) {
    console.error("Erreur lors de la mise en évidence du pack populaire:", error);
  }
}

// Appeler la fonction pour mettre en évidence l'option visuelle après le chargement du DOM
document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function () {
    // Tenter d'obtenir les variantes populaires à partir du script JSON dans le DOM
    const variantsDataElement = document.getElementById("variants-data");
    if (variantsDataElement) {
      try {
        const variantsData = JSON.parse(variantsDataElement.textContent);
        const popularVariants = variantsData.filter((v) => v.populaire && v.populaire.toLowerCase() === "populaire");

        if (popularVariants.length > 0) {
          // Appliquer le badge à l'interface visuelle des packs
          highlightVisualPackOption(popularVariants[0].id);
        }
      } catch (error) {
        console.error("Erreur lors de la recherche des variantes populaires:", error);
      }
    }
  }, 1000);
});

// Appeler également la fonction directement pour les thèmes qui modifient le DOM dynamiquement
setTimeout(function () {
  // Vérifier si un input hidden avec la variante populaire existe
  const variantsDataElement = document.getElementById("variants-data");
  if (variantsDataElement) {
    try {
      const variantsData = JSON.parse(variantsDataElement.textContent);
      const popularVariants = variantsData.filter((v) => v.populaire && v.populaire.toLowerCase() === "populaire");

      if (popularVariants.length > 0) {
        highlightVisualPackOption(popularVariants[0].id);
      }
    } catch (error) {
      console.error("Erreur lors de la seconde tentative:", error);
    }
  }
}, 2000);

// Également appliquer lors des changements de variante
document.addEventListener("variant:change", function (e) {
  if (e.detail && e.detail.variant) {
    // Vérifier si la variante est populaire
    const variantsDataElement = document.getElementById("variants-data");
    if (variantsDataElement) {
      try {
        const variantsData = JSON.parse(variantsDataElement.textContent);
        const isPopular = variantsData.some((v) => v.id === e.detail.variant.id && v.populaire && v.populaire.toLowerCase() === "populaire");

        // Si c'est la variante populaire, mettre en évidence le visuel
        if (isPopular) {
          highlightVisualPackOption(e.detail.variant.id);
        }
        // Si ce n'est pas la variante populaire, masquer tous les badges "Populaire"
        else {
          hideAllPopularBadges();
        }
      } catch (error) {
        console.error("Erreur lors de la vérification de variante populaire:", error);
      }
    }
  }
});

// Ajouter des écouteurs pour tous les événements potentiels de changement de variante/option
document.addEventListener("DOMContentLoaded", function () {
  // Observer les clics sur les options de pack/variantes
  document.body.addEventListener("click", function (e) {
    // Détecter les clics sur les options de pack
    const packOption = e.target.closest(".bundle-option, .variant-option, [data-quantity], [data-variant-id]");
    if (packOption) {
      console.log("Clic sur une option de pack détecté:", packOption);

      // Vérifier si l'option cliquée est populaire
      const popularBadge = document.querySelector(".block-with-info--v3__badge:not(.block-with-info--v3__badge--hidden)");
      if (popularBadge) {
        // Si on avait un badge visible, vérifier si on doit le garder
        setTimeout(updatePopularBadgeVisibility, 100);
      }
    }
  });

  // Observer aussi les changements de classe pour détecter les sélections d'options
  const observer = new MutationObserver(function (mutations) {
    let needsUpdate = false;

    for (const mutation of mutations) {
      if (mutation.type === "attributes" && (mutation.attributeName === "class" || mutation.attributeName === "data-variant-id")) {
        const target = mutation.target;
        if (target.classList.contains("selected") || target.classList.contains("active") || target.hasAttribute("data-variant-id")) {
          needsUpdate = true;
          break;
        }
      }
    }

    if (needsUpdate) {
      console.log("Changement de sélection détecté");
      setTimeout(updatePopularBadgeVisibility, 100);
    }
  });

  // Observer les changements dans tout le document
  observer.observe(document.body, {
    attributes: true,
    subtree: true,
    attributeFilter: ["class", "data-variant-id"],
  });
});

// Fonction pour mettre à jour la visibilité du badge populaire
function updatePopularBadgeVisibility() {
  // console.log('Mise à jour de la visibilité du badge populaire');

  // Récupérer l'ID de la variante actuellement sélectionnée
  const selectedVariantInput =
    document.querySelector('input[name="id"]:checked') ||
    document.querySelector('input[name="id"][type="hidden"]') ||
    document.querySelector('select[name="id"]');

  if (!selectedVariantInput) {
    console.warn("Aucune variante sélectionnée trouvée");
    return;
  }

  // Pour un select, nous devons obtenir l'option sélectionnée
  let selectedVariantId;
  if (selectedVariantInput.tagName === "SELECT") {
    selectedVariantId = selectedVariantInput.value;
  } else {
    selectedVariantId = selectedVariantInput.value;
  }

  console.log("Variante actuellement sélectionnée:", selectedVariantId);

  // Vérifier si c'est la variante populaire
  const variantsDataElement = document.getElementById("variants-data");
  if (variantsDataElement) {
    try {
      const variantsData = JSON.parse(variantsDataElement.textContent);
      console.log(
        "Toutes les variantes disponibles:",
        variantsData.map((v) => ({ id: v.id, populaire: v.populaire, limit: v.limit }))
      );

      const popularVariant = variantsData.find((v) => v.populaire && v.populaire.toLowerCase() === "populaire");

      // Trouver TOUTES les variantes populaires, pas seulement la première
      const allPopularVariants = variantsData.filter((v) => v.populaire && v.populaire.toLowerCase() === "populaire");

      console.log(
        "Variantes populaires trouvées:",
        allPopularVariants.map((v) => ({ id: v.id, limit: v.limit }))
      );

      if (allPopularVariants.length > 0) {
        // Chercher d'abord si la variante sélectionnée est directement populaire
        const selectedPopularVariant = allPopularVariants.find((v) => v.id === selectedVariantId);
        const popularVariant = selectedPopularVariant || allPopularVariants[0];

        console.log("Variante populaire utilisée:", popularVariant.id);

        // Vérification principale : est-ce que l'ID correspond exactement?
        const isExactMatch = popularVariant.id === selectedVariantId;

        // Vérification secondaire : est-ce que c'est le même type/taille de pack?
        let isSamePackSize = false;

        // Si nous avons des informations sur la taille du pack
        if (popularVariant.limit) {
          const selectedVariant = variantsData.find((v) => v.id === selectedVariantId);
          if (selectedVariant && selectedVariant.limit) {
            // Comparer les tailles de pack
            isSamePackSize = popularVariant.limit === selectedVariant.limit;
          }
        }

        // STRICT : Seules les variantes explicitement marquées comme populaires affichent le badge
        const selectedVariant = variantsData.find((v) => v.id === selectedVariantId);
        const isSelectedVariantPopular = selectedVariant && selectedVariant.populaire && selectedVariant.populaire.toLowerCase() === "populaire";

        // CONDITION STRICTE : Seulement si la variante est EXPLICITEMENT populaire
        if (isSelectedVariantPopular && !badgeAlreadyDisplayed) {
          console.log("🚀 BADGE DÉTECTÉ - Variante explicitement marquée comme populaire");
          console.log("   - isSelectedVariantPopular:", isSelectedVariantPopular);
          console.log("   - Variante ID:", selectedVariantId);

          // NETTOYER D'ABORD tous les badges existants pour éviter les doublons
          document.querySelectorAll(".block-with-info--v3__badge").forEach((badge) => {
            if (badge.textContent && badge.textContent.toLowerCase().includes("populaire")) {
              badge.classList.add("block-with-info--v3__badge--hidden");
              badge.style.display = "none";
            }
          });

          // Utiliser l'ID de la variante sélectionnée (qui est populaire)
          const badgeVariantId = selectedVariantId;
          console.log("🎯 ID de variante pour le badge:", badgeVariantId);

          // Marquer le badge comme affiché de manière permanente
          badgeAlreadyDisplayed = true;
          lastPopularVariantId = badgeVariantId;

          // Mettre en évidence le badge populaire avec un délai pour laisser le DOM se mettre à jour
          setTimeout(() => {
            console.log("⏰ APPEL UNIQUE de highlightVisualPackOption pour badge permanent");
            highlightVisualPackOption(badgeVariantId);
          }, 200);
        } else if (badgeAlreadyDisplayed) {
          console.log("🔒 BADGE DÉJÀ AFFICHÉ - Aucune action nécessaire, badge permanent actif");
        } else {
          console.log("🔒 BADGE PERMANENT - Le badge populaire reste affiché même sur variante non-populaire");
          // NE PLUS MASQUER LE BADGE - il reste permanent une fois affiché
        }
      } else {
        console.log("Aucune variante populaire trouvée dans les données");
        hideAllPopularBadges();
      }
    } catch (error) {
      console.error("Erreur lors de la vérification des variantes:", error);
      hideAllPopularBadges();
    }
  } else {
    console.warn("Élément variants-data non trouvé");
    hideAllPopularBadges();
  }
}

// Fonction pour masquer tous les badges "Populaire" - DÉSACTIVÉE pour badge permanent
function hideAllPopularBadges() {
  if (badgeAlreadyDisplayed) {
    console.log("🔒 MASQUAGE INTERDIT - Badge populaire permanent, ne peut pas être masqué");
    return;
  }

  // Supprimer SEULEMENT les badges indésirables (bordures rouges, etc.)
  document.querySelectorAll(".floating-popular-badge, .pack-popular-badge, .badge-populaire-forced, .popular-badge, .radio-badge-wrapper").forEach((badge) => {
    badge.remove();
  });

  console.log("🧹 Nettoyage des badges indésirables uniquement (badge principal préservé)");
}

// Protection contre les boucles infinies
let isUpdatingBadge = false;
let lastPopularVariantId = null;
let badgeAlreadyDisplayed = false; // Badge permanent - ne s'affiche qu'une fois

// Fonction pour appliquer le badge après n'importe quel changement de DOM
function reapplyPopularBadgeIfNeeded() {
  if (isUpdatingBadge) {
    console.log("🚫 BOUCLE DÉTECTÉE - Ignorer la mise à jour du badge");
    return;
  }
  isUpdatingBadge = true;
  updatePopularBadgeVisibility();
  setTimeout(() => {
    isUpdatingBadge = false;
  }, 500);
}

// Indicateur de changement récent pour le suivi de la fréquence
let recentVariantChange = false;

// Observer temporairement désactivé pour éviter les boucles infinies
// const popularBadgeObserver = new MutationObserver(function(mutations) {
//   // Code commenté pour éviter les boucles
// });

// Observer temporairement désactivé - Démarrer l'observation après le chargement du DOM
document.addEventListener("DOMContentLoaded", function () {
  // popularBadgeObserver.observe(document.body, {
  //   childList: true,
  //   subtree: true,
  //   attributes: true,
  //   attributeFilter: ['class', 'data-variant-id', 'name']
  // });

  // Vérification périodique désactivée temporairement
  // setInterval(reapplyPopularBadgeIfNeeded, 2000);

  // Écouter les clics sur le document pour capturer les changements de variante
  document.addEventListener("click", function (e) {
    // Si on a cliqué sur un élément qui pourrait changer la variante
    if (e.target.closest('.variant-option, .bundle-option, [data-variant-id], select[name="id"], input[name="id"]')) {
      recentVariantChange = true;

      // Vérifier plusieurs fois après un clic
      for (let i = 1; i <= 5; i++) {
        setTimeout(reapplyPopularBadgeIfNeeded, i * 300);
      }

      // Réinitialiser l'indicateur après la séquence de vérifications
      setTimeout(() => {
        recentVariantChange = false;
      }, 3000);
    }
  });
});

// Ajouter une écoute spécifique pour les changements de variante via l'événement natif
document.addEventListener("variant:change", function (event) {
  console.log("Événement variant:change détecté", event.detail);

  // Démarrer une séquence de vérifications plus rapide
  recentVariantChange = true;

  // Vérifier immédiatement
  reapplyPopularBadgeIfNeeded();

  // Puis vérifier à intervalles courts pendant un moment
  for (let i = 1; i <= 10; i++) {
    setTimeout(reapplyPopularBadgeIfNeeded, i * 200);
  }

  // Après la séquence, revenir à la vérification normale
  setTimeout(() => {
    recentVariantChange = false;
  }, 3000);
});
